"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightPalette = exports.darkPalette = exports.getCybertronTheme = exports.monospaceInputStyles = exports.getInlineInputStyles = exports.getAccessibleForegroundColor = exports.MONOSPACE_FONT_FAMILY = exports.DENSE_MENU_ITEM_HEIGHT = exports.DEFAULT_MENU_ITEM_HEIGHT = exports.SPACING_FACTOR = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const chroma_js_1 = __importDefault(require("chroma-js"));
require("@sbu/fonts.labgrotesque");
const material_1 = require("@mui/material");
const check_svg_1 = __importDefault(require("@sbu/assets.svg/src/check.svg"));
const close_svg_1 = __importDefault(require("@sbu/assets.svg/src/close.svg"));
const info_svg_1 = __importDefault(require("@sbu/assets.svg/src/info.svg"));
const malicious_svg_1 = __importDefault(require("@sbu/assets.svg/src/malicious.svg"));
const remove_svg_1 = __importDefault(require("@sbu/assets.svg/src/remove.svg"));
const single_chevron_down_svg_1 = __importDefault(require("@sbu/assets.svg/src/single-chevron-down.svg"));
const single_chevron_left_svg_1 = __importDefault(require("@sbu/assets.svg/src/single-chevron-left.svg"));
const single_chevron_right_svg_1 = __importDefault(require("@sbu/assets.svg/src/single-chevron-right.svg"));
const success_svg_1 = __importDefault(require("@sbu/assets.svg/src/success.svg"));
const suspicious_svg_1 = __importDefault(require("@sbu/assets.svg/src/suspicious.svg"));
const darkPalette_1 = require("./darkPalette");
const lightPalette_1 = require("./lightPalette");
const shapes_1 = require("./shapes");
const typography_1 = require("./typography");
Object.defineProperty(exports, "MONOSPACE_FONT_FAMILY", { enumerable: true, get: function () { return typography_1.MONOSPACE_FONT_FAMILY; } });
const YamaColors_1 = __importDefault(require("./YamaColors"));
exports.SPACING_FACTOR = 8;
exports.DEFAULT_MENU_ITEM_HEIGHT = exports.SPACING_FACTOR * 5;
exports.DENSE_MENU_ITEM_HEIGHT = exports.SPACING_FACTOR * 3.5;
const getAccessibleForegroundColor = (backgroundColor) => {
    return (0, chroma_js_1.default)(backgroundColor).luminance() < 0.18
        ? 'common.white'
        : 'common.black';
};
exports.getAccessibleForegroundColor = getAccessibleForegroundColor;
const getInlineInputStyles = (label) => {
    return {
        fontSize: 'inherit',
        [`.${material_1.inputClasses.input}.${material_1.selectClasses.select}, .${material_1.inputClasses.input}.${material_1.autocompleteClasses.input}, .${material_1.inputBaseClasses.input}.${material_1.inputClasses.input}`]: { color: 'link.main', paddingTop: 0, paddingBottom: 0 },
        [`&.${material_1.inputBaseClasses.root}.${material_1.inputClasses.root}`]: {
            marginTop: label ? 1.5 : 0,
        },
    };
};
exports.getInlineInputStyles = getInlineInputStyles;
exports.monospaceInputStyles = {
    fontFamily: typography_1.MONOSPACE_FONT_FAMILY,
};
// TODO: Adjust h5 and h6 styling when appropriate. For now, do not use
const getCybertronTheme = (mode) => {
    const { background, border, chart, common, divider, error, grey, icon, info, link, primary, secondary, status, success, tertiary, text, warning, reputation, toast, dataGrid, } = mode === 'dark' ? darkPalette_1.darkPalette : lightPalette_1.lightPalette;
    const { h1, h2, h3, h4, h5, h6, subtitle1, subtitle2, body1, body2, button, caption, code, } = (0, typography_1.getTypography)(text);
    // Icon Components =====================================================
    const CloseIcon = (props) => ((0, jsx_runtime_1.jsx)(close_svg_1.default, Object.assign({ "aria-hidden": true, height: 10, role: 'img', width: 10, color: icon }, props)));
    const SelectIcon = () => ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, { "aria-hidden": true, component: single_chevron_down_svg_1.default, sx: {
            color: 'icon',
            height: 8,
            width: 8,
        } }));
    const InfoIcon = (_a) => {
        var { sx: sxProps } = _a, restProps = __rest(_a, ["sx"]);
        return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, Object.assign({ "aria-hidden": true, component: info_svg_1.default, sx: Object.assign({ color: 'icon', height: 14, width: 14 }, sxProps) }, restProps)));
    };
    const SuccessIcon = (_a) => {
        var { sx: sxProps } = _a, restProps = __rest(_a, ["sx"]);
        return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, Object.assign({ "aria-hidden": true, component: success_svg_1.default, sx: Object.assign({ color: 'success.main', height: 14, width: 14 }, sxProps) }, restProps)));
    };
    const MaliciousIcon = (_a) => {
        var { sx: sxProps } = _a, restProps = __rest(_a, ["sx"]);
        return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, Object.assign({ "aria-hidden": true, component: malicious_svg_1.default, sx: Object.assign({ color: 'warning.main', height: 14, width: 14 }, sxProps) }, restProps)));
    };
    const SuspiciousIcon = (_a) => {
        var { sx: sxProps } = _a, restProps = __rest(_a, ["sx"]);
        return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, Object.assign({ "aria-hidden": true, component: suspicious_svg_1.default, sx: Object.assign({ color: 'error.main', height: 14, width: 14 }, sxProps) }, restProps)));
    };
    // Exportable Objects ==========================================================
    const tooltipStyles = Object.assign(Object.assign({}, body2), { backgroundColor: background.contrast, display: 'flex', maxWidth: '200px', padding: exports.SPACING_FACTOR, position: 'relative', [`&, .${material_1.typographyClasses.root}`]: {
            lineHeight: 'normal',
            color: text.contrast,
        }, [`.${material_1.buttonClasses.root}`]: Object.assign(Object.assign({}, body2), { backgroundColor: 'transparent', fontWeight: 500, padding: 0, minWidth: 'auto', height: 'auto', '&, &:hover, &:focus': {
                color: text.contrast,
            } }) });
    // Shape =======================================================================
    const shape = {
        borderRadius: 0,
        polygon: shapes_1.createPolygon,
    };
    // Overrides ===================================================================
    const menuItemHoverStyles = {
        backgroundColor: background.chip,
    };
    const menuItemFocusedStyles = menuItemHoverStyles;
    const menuItemSelectedStyles = {
        backgroundColor: secondary.light,
        '&:hover, &:focus': Object.assign({}, menuItemHoverStyles),
    };
    const menuItemDisabledStyles = {
        opacity: 0.5,
    };
    const sharedPaperStyles = {
        backgroundColor: 'background.paper',
        backgroundImage: 'none',
        border: '1px solid',
        borderColor: border,
    };
    const popperAndPopoverPaperStyles = {
        backgroundImage: 'none',
        [`&.${material_1.paperClasses.root}`]: Object.assign({}, sharedPaperStyles),
    };
    const MuiAccordion = {
        defaultProps: {
            disableGutters: true,
            elevation: 0,
            square: true,
        },
        styleOverrides: {
            root: {
                backgroundColor: 'transparent',
                boxSizing: 'content-box',
                width: '100%',
                '&:before': {
                    top: 0,
                    height: 0,
                },
                [`&.${material_1.accordionClasses.disabled}`]: {
                    backgroundColor: background.paper,
                    opacity: 0.5,
                },
                [`&.${material_1.accordionClasses.expanded}`]: {
                    border: 'none',
                    margin: 0,
                },
            },
        },
    };
    const MuiAccordionDetails = {
        styleOverrides: {
            root: {
                boxSizing: 'content-box',
                background: background.paperHover,
                paddingBottom: 16,
                paddingLeft: 16,
                paddingRight: 16,
                paddingTop: 16,
            },
        },
    };
    const MuiAccordionSummary = {
        styleOverrides: {
            content: Object.assign(Object.assign({}, subtitle1), { alignItems: 'center', boxSizing: 'content-box', color: text.primary, gap: 12, minHeight: 28, margin: 0, [`&.${material_1.accordionSummaryClasses.expanded} svg`]: {
                    transform: 'rotate(-180deg)',
                } }),
            root: {
                minHeight: 28,
                paddingLeft: exports.SPACING_FACTOR * 2,
                paddingRight: exports.SPACING_FACTOR * 2,
                svg: {
                    transform: 'rotate(0deg)',
                    transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                },
                [`&.${material_1.accordionSummaryClasses.disabled}`]: {
                    opacity: 1,
                },
                [`&.${material_1.accordionSummaryClasses.expanded}`]: {
                    borderBottom: '1px solid',
                    borderColor: border,
                    minHeight: 28,
                },
                [`&.${material_1.accordionSummaryClasses.expandIconWrapper}.${material_1.accordionSummaryClasses.expanded} svg`]: {
                    transform: 'rotate(180deg)',
                },
            },
        },
    };
    const MuiAlert = {
        defaultProps: {
            variant: 'standard',
            iconMapping: {
                info: (0, jsx_runtime_1.jsx)(InfoIcon, {}),
                success: (0, jsx_runtime_1.jsx)(SuccessIcon, {}),
                warning: (0, jsx_runtime_1.jsx)(MaliciousIcon, {}),
                error: (0, jsx_runtime_1.jsx)(SuspiciousIcon, {}),
            },
        },
        styleOverrides: {
            root: Object.assign(Object.assign({}, body2), { color: text.primary, display: 'flex', alignItems: 'center', [`&.${material_1.paperClasses.root}`]: {
                    backgroundColor: background.paper,
                    padding: `0 ${exports.SPACING_FACTOR * 2}px 0 0`,
                    borderLeft: '4px solid',
                } }),
            icon: {
                marginRight: exports.SPACING_FACTOR * 0.75,
                marginLeft: exports.SPACING_FACTOR * 2,
                padding: `${exports.SPACING_FACTOR}px 0px`,
            },
        },
        variants: [
            {
                props: { severity: 'info' },
                style: {
                    [`&.${material_1.alertClasses.icon}`]: {
                        color: icon,
                    },
                    [`&.${material_1.paperClasses.root}`]: {
                        borderLeftColor: icon,
                    },
                },
            },
            {
                props: { severity: 'error' },
                style: {
                    [`&.${material_1.alertClasses.icon}`]: {
                        color: error.main,
                    },
                    [`&.${material_1.paperClasses.root}`]: {
                        borderLeftColor: error.main,
                    },
                },
            },
            {
                props: { severity: 'warning' },
                style: {
                    [`&.${material_1.alertClasses.icon}`]: {
                        color: warning.main,
                    },
                    [`&.${material_1.paperClasses.root}`]: {
                        borderLeftColor: warning.main,
                    },
                },
            },
            {
                props: { severity: 'success' },
                style: {
                    [`&.${material_1.alertClasses.icon}`]: {
                        color: success.main,
                    },
                    [`&.${material_1.paperClasses.root}`]: {
                        borderLeftColor: success.main,
                    },
                },
            },
        ],
    };
    const MuiAutocomplete = {
        defaultProps: {
            clearIcon: (0, jsx_runtime_1.jsx)(CloseIcon, {}),
            popupIcon: (0, jsx_runtime_1.jsx)(SelectIcon, {}),
            slotProps: {
                paper: {
                    elevation: 0,
                },
            },
        },
        styleOverrides: {
            inputRoot: {
                paddingBottom: 0,
                [`.${material_1.inputClasses.input}`]: {
                    paddingTop: exports.SPACING_FACTOR / 2,
                    paddingBottom: exports.SPACING_FACTOR / 2,
                },
            },
            clearIndicator: {
                paddingTop: 0.25 * exports.SPACING_FACTOR,
                paddingBottom: 0.25 * exports.SPACING_FACTOR,
                paddingLeft: 0.5 * exports.SPACING_FACTOR,
                paddingRight: 0.5 * exports.SPACING_FACTOR,
            },
            groupUl: {
                '& .MuiAutocomplete-option': {
                    paddingLeft: exports.SPACING_FACTOR * 2,
                },
            },
            listbox: {
                '& .MuiAutocomplete-option': {
                    paddingBottom: exports.SPACING_FACTOR,
                    paddingLeft: 2 * exports.SPACING_FACTOR,
                    paddingRight: 2 * exports.SPACING_FACTOR,
                    paddingTop: exports.SPACING_FACTOR,
                },
            },
            paper: {
                // Needed for some extra specificity
                '&.MuiPaper-root': Object.assign(Object.assign({}, sharedPaperStyles), { marginTop: exports.SPACING_FACTOR, '.MuiAutocomplete-listbox': {
                        padding: 0,
                        '& .MuiAutocomplete-option': {
                            '&:hover': menuItemHoverStyles,
                            '&:focus, &.Mui-focused': menuItemFocusedStyles,
                            '&[aria-selected="true"]': menuItemSelectedStyles,
                            '&:disabled, &.Mui-disabled': menuItemDisabledStyles,
                        },
                    } }),
            },
            popupIndicator: {
                marginRight: 4,
                transform: 'rotate(0deg)',
                transition: 'all 0.3s ease-in-out',
                '& svg': {
                    marginRight: '0 !important',
                },
            },
            popupIndicatorOpen: {
                transform: 'rotate(-180deg)',
            },
        },
    };
    const MuiBadge = {
        defaultProps: {
            variant: 'dot',
        },
        styleOverrides: {
            dot: {
                height: 0.75 * exports.SPACING_FACTOR,
                minWidth: 0.75 * exports.SPACING_FACTOR,
            },
        },
    };
    const MuiButton = {
        defaultProps: {
            disableFocusRipple: true,
            disableRipple: true,
            disableTouchRipple: true,
            disableElevation: true,
        },
        styleOverrides: {
            root: {
                textTransform: 'none',
                fontSize: '1rem',
                lineHeight: 'normal',
            },
        },
        variants: [
            // Size Styling
            {
                props: { size: 'medium' },
                style: {
                    '.MuiButton-startIcon, .MuiButton-endIcon': {
                        svg: {
                            height: 16,
                            width: 16,
                        },
                    },
                },
            },
            {
                props: { size: 'medium', variant: 'contained' },
                style: {
                    minWidth: 100,
                    height: 36,
                    padding: `0px ${exports.SPACING_FACTOR * 1.5}px`,
                },
            },
            {
                props: { size: 'medium', variant: 'text' },
                style: {
                    minWidth: 100,
                    height: 36,
                    padding: `0px ${exports.SPACING_FACTOR * 1.5}px`,
                },
            },
            {
                props: { size: 'small' },
                style: {
                    fontSize: '.857rem',
                    '.MuiButton-startIcon, .MuiButton-endIcon': {
                        svg: {
                            height: 14,
                            width: 14,
                        },
                    },
                },
            },
            {
                props: { size: 'small', variant: 'contained' },
                style: {
                    height: 28,
                    padding: `0px ${exports.SPACING_FACTOR * 1.5}px`,
                },
            },
            {
                props: { size: 'small', variant: 'text' },
                style: {
                    height: 28,
                    padding: `0px ${exports.SPACING_FACTOR * 1.5}px`,
                },
            },
            {
                props: { variant: 'outlined' },
                style: {
                    padding: `${exports.SPACING_FACTOR * 0.75}px ${exports.SPACING_FACTOR * 1.5}px`,
                },
            },
            // Contained Variant Styling
            {
                props: { variant: 'contained' },
                style: {
                    fontWeight: 400,
                    '&:disabled, &.Mui-disabled': {
                        opacity: 0.5,
                    },
                },
            },
            {
                props: { variant: 'contained', color: 'primary' },
                style: {
                    backgroundColor: primary.main,
                    '&, &:visited': {
                        color: primary.contrastText,
                    },
                    '&:hover, &:focus': {
                        backgroundColor: primary.light,
                    },
                    '&:active': {
                        backgroundColor: primary.dark,
                    },
                    '&:disabled, &.Mui-disabled': {
                        backgroundColor: primary.main,
                        color: primary.contrastText,
                    },
                    [`&.${material_1.buttonClasses.loading}`]: {
                        color: 'transparent',
                    },
                    [`& .${material_1.buttonClasses.loadingIndicator}`]: {
                        color: primary.contrastText,
                    },
                },
            },
            {
                props: { variant: 'contained', color: 'secondary' },
                style: {
                    backgroundColor: secondary.main,
                    '&, &:visited': {
                        color: secondary.contrastText,
                    },
                    '&:hover, &:focus': {
                        backgroundColor: secondary.light,
                    },
                    '&:active': {
                        backgroundColor: secondary.dark,
                    },
                    '&:disabled, &.Mui-disabled': {
                        color: secondary.contrastText,
                        backgroundColor: secondary.main,
                    },
                    [`&.${material_1.buttonClasses.loading}`]: {
                        color: 'transparent',
                    },
                    [`& .${material_1.buttonClasses.loadingIndicator}`]: {
                        color: secondary.contrastText,
                    },
                },
            },
            {
                props: { variant: 'contained', color: 'error' },
                style: {
                    backgroundColor: error.main,
                    '&, &:visited': {
                        color: error.contrastText,
                    },
                    '&:hover, &:focus': {
                        backgroundColor: error.light,
                    },
                    '&:active': {
                        backgroundColor: error.dark,
                    },
                    '&:disabled, &.Mui-disabled': {
                        backgroundColor: error.main,
                        color: error.contrastText,
                    },
                    [`&.${material_1.buttonClasses.loading}`]: {
                        color: 'transparent',
                    },
                    [`& .${material_1.buttonClasses.loadingIndicator}`]: {
                        color: error.contrastText,
                    },
                },
            },
            // Text Variant Styling
            {
                props: { variant: 'text' },
                style: {
                    '&, &:visited': {
                        color: text.primary,
                    },
                    '&, .MuiTypography-root': {
                        fontWeight: 500,
                    },
                    '&, &:hover, &:focus': {
                        backgroundColor: 'transparent',
                    },
                    '&:disabled, &.Mui-disabled': {
                        opacity: 0.5,
                    },
                },
            },
            {
                props: { variant: 'text', color: 'primary' },
                style: {
                    '&, &:visited': {
                        color: text.primary,
                    },
                    '&:hover, &:focus': {
                        color: primary.light,
                    },
                    '&:active': {
                        color: primary.dark,
                    },
                    '&:disabled, &.Mui-disabled': {
                        color: text.primary,
                    },
                    [`&.${material_1.buttonClasses.loading}`]: {
                        color: 'transparent',
                    },
                    [`& .${material_1.buttonClasses.loadingIndicator}`]: {
                        color: text.primary,
                    },
                },
            },
            {
                props: { variant: 'text', color: 'secondary' },
                style: {
                    '&, &:visited': {
                        color: tertiary.main,
                    },
                    '&:hover, &:focus': {
                        color: tertiary.light,
                    },
                    '&:active': {
                        color: tertiary.dark,
                    },
                    '&:disabled, &.Mui-disabled': {
                        color: tertiary.main,
                    },
                    [`&.${material_1.buttonClasses.loading}`]: {
                        color: 'transparent',
                    },
                    [`& .${material_1.buttonClasses.loadingIndicator}`]: {
                        color: tertiary.main,
                    },
                },
            },
            // Outlined Variant Styling
            {
                props: { variant: 'outlined' },
                style: {
                    fontWeight: 500,
                    '&': {
                        color: link.main,
                    },
                    '&:hover, &:focus': {
                        borderColor: primary.light,
                    },
                    '&:active': {
                        borderColor: primary.dark,
                    },
                    '&:disabled, &.Mui-disabled': {
                        borderColor: link.main,
                        opacity: 0.5,
                    },
                    [`&.${material_1.buttonClasses.loading}`]: {
                        color: 'transparent',
                    },
                },
            },
        ],
    };
    const MuiButtonBase = {
        defaultProps: {
            disableTouchRipple: true,
        },
    };
    const MuiBreadcrumbs = {
        defaultProps: {
            separator: ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, { "aria-hidden": true, component: single_chevron_right_svg_1.default, sx: {
                    color: 'icon',
                    height: 12,
                    width: 12,
                } })),
        },
        styleOverrides: {
            li: {
                color: text.primary,
                [`.${material_1.typographyClasses.root}.${material_1.linkClasses.root}`]: {
                    '&, &:visited': {
                        color: link.main,
                        '&:hover, &:focus, &:focus-visible': {
                            color: link.hover,
                        },
                    },
                },
            },
        },
    };
    const MuiCard = {
        styleOverrides: {
            root: {
                backgroundImage: 'none',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                bgcolor: background.paper,
                border: '1px solid',
                borderColor: border,
            },
        },
    };
    const MuiCardActions = {
        styleOverrides: {
            root: {
                backgroundColor: background.default,
                borderTop: '1px solid',
                borderColor: border,
                flexDirection: 'column',
            },
        },
    };
    const MuiCardContent = {
        styleOverrides: {
            root: {
                padding: '16px 40px 0',
            },
        },
    };
    const MuiCheckbox = {
        defaultProps: {
            checkedIcon: ((0, jsx_runtime_1.jsx)(material_1.Zoom, { in: true, children: (0, jsx_runtime_1.jsx)(material_1.SvgIcon, { sx: {
                        color: YamaColors_1.default['white-30'],
                    }, children: (0, jsx_runtime_1.jsx)(check_svg_1.default, {}) }) })),
            disableFocusRipple: true,
            disableRipple: true,
            disableTouchRipple: true,
            indeterminateIcon: ((0, jsx_runtime_1.jsx)(material_1.Zoom, { in: true, children: (0, jsx_runtime_1.jsx)(material_1.SvgIcon, { inheritViewBox: true, sx: {
                        px: 0.25,
                        color: info.contrastText,
                    }, children: (0, jsx_runtime_1.jsx)(remove_svg_1.default, { height: '100%', width: '100%' }) }) })),
        },
        styleOverrides: {
            root: {
                border: '2px solid',
                borderColor: icon,
                borderRadius: 0,
                boxSizing: 'border-box',
                color: primary.contrastText,
                padding: 0,
                '&:hover, &:active': {
                    borderColor: primary.main,
                },
                '& svg': {
                    backgroundColor: primary.main,
                    fill: primary.contrastText,
                },
                [`&.${material_1.checkboxClasses.sizeSmall}`]: {
                    height: 14,
                    width: 14,
                    '& svg': {
                        height: 10,
                        width: 10,
                    },
                },
                [`&.${material_1.checkboxClasses.sizeMedium}`]: {
                    height: 16,
                    width: 16,
                    '& svg': {
                        height: 12,
                        width: 12,
                    },
                },
                [`&.${material_1.checkboxClasses.indeterminate}`]: {
                    borderColor: primary.main,
                    color: primary.contrastText,
                    '&:hover, &:active': {
                        borderColor: primary.light,
                        '& svg': {
                            backgroundColor: primary.light,
                        },
                    },
                    [`&.${material_1.checkboxClasses.disabled}`]: {
                        borderColor: primary.main,
                        '& svg': {
                            backgroundColor: primary.main,
                        },
                    },
                },
                [`&.${material_1.checkboxClasses.checked}`]: {
                    borderColor: primary.main,
                    '&:hover, &:active': {
                        borderColor: primary.light,
                        '& svg': {
                            backgroundColor: primary.light,
                        },
                    },
                    [`&.${material_1.checkboxClasses.disabled}`]: {
                        borderColor: primary.main,
                        '& svg': {
                            backgroundColor: primary.main,
                        },
                    },
                },
                [`&.${material_1.checkboxClasses.disabled}`]: {
                    borderColor: info.dark,
                },
                [`:not(.${material_1.checkboxClasses.checked}):not(.${material_1.checkboxClasses.indeterminate}) .${material_1.svgIconClasses.root}`]: {
                    visibility: 'hidden',
                },
            },
        },
    };
    const MuiChip = {
        defaultProps: {
            variant: 'filled',
        },
        styleOverrides: {
            label: {
                width: '100%',
            },
            outlined: {
                border: '1px solid',
                borderColor: info.dark,
            },
            root: {
                backgroundColor: background.chip,
                borderRadius: 0,
                boxSizing: 'border-box',
                '&.Mui-disabled': {
                    opacity: 0.5,
                },
            },
            sizeMedium: Object.assign(Object.assign({}, body1), { height: 'auto', minHeight: 24, '& .MuiChip-label': {
                    display: 'block',
                    justifyContent: 'space-between',
                    paddingTop: 0.375 * exports.SPACING_FACTOR,
                    paddingBottom: 0.375 * exports.SPACING_FACTOR,
                    paddingLeft: exports.SPACING_FACTOR,
                    paddingRight: exports.SPACING_FACTOR,
                    whiteSpace: 'normal',
                } }),
            sizeSmall: Object.assign(Object.assign({}, body2), { height: 18, minWidth: 18, '& .MuiChip-label': {
                    color: text.secondary,
                    justifyContent: 'center',
                    paddingLeft: 0.25 * exports.SPACING_FACTOR,
                    paddingRight: 0.25 * exports.SPACING_FACTOR,
                } }),
        },
    };
    const MuiCssBaseline = {
        styleOverrides: {
            html: {
                fontSize: 14,
            },
            body: {
                fontSize: 14,
                lineHeight: 1.1,
            },
            a: {
                fontSize: '0.875rem',
                transition: 'color 0.3s',
                textDecoration: 'none',
                backgroundColor: 'transparent',
                ':hover': {
                    color: link.hover,
                    textDecoration: 'none',
                },
            },
        },
    };
    const MuiFormControlLabel = {
        styleOverrides: {
            root: {
                color: text.primary,
                margin: 0,
                [`&.${material_1.formControlLabelClasses.disabled}`]: {
                    color: text.primary,
                    opacity: 0.5,
                    cursor: 'not-allowed',
                },
            },
            label: {
                [`&.${material_1.formControlLabelClasses.disabled}`]: {
                    color: text.primary,
                },
            },
        },
    };
    const MuiFormHelperText = {
        styleOverrides: {
            root: Object.assign(Object.assign({}, body2), { lineHeight: 'normal', color: text.secondary, [`'&.${material_1.formHelperTextClasses.error}'`]: {
                    color: text.error,
                } }),
        },
    };
    const MuiFormLabel = {
        styleOverrides: {
            root: {
                [`&.${material_1.inputLabelClasses.shrink}`]: {
                    lineHeight: 'normal',
                    transform: 'none',
                },
                [`&:not(.${material_1.inputLabelClasses.shrink})`]: {
                    paddingTop: exports.SPACING_FACTOR / 2,
                },
                [`&.${material_1.inputLabelClasses.focused}, &.${material_1.inputLabelClasses.focused} .${material_1.formLabelClasses.asterisk}, &.${material_1.inputClasses.error}, &:not(${material_1.inputClasses.focused}), .${material_1.formLabelClasses.asterisk}.${material_1.inputLabelClasses.error}, &.${material_1.inputLabelClasses.disabled}`]: {
                    color: text.secondary,
                },
            },
        },
    };
    const MuiDialog = {
        styleOverrides: {
            root: {
                '& .MuiPaper-root': {
                    backgroundImage: 'none',
                    border: '1px solid',
                    borderColor: border,
                    maxHeight: '80vh',
                    padding: 4 * exports.SPACING_FACTOR,
                },
                paper: {
                    backgroundImage: 'none',
                },
            },
        },
    };
    const MuiDialogActions = {
        defaultProps: {},
        styleOverrides: {
            root: {
                padding: 0,
            },
        },
    };
    const MuiDialogContent = {
        defaultProps: {},
        styleOverrides: {
            root: Object.assign(Object.assign({}, body1), { marginBottom: 2 * exports.SPACING_FACTOR, padding: 0 }),
        },
    };
    const MuiDialogTitle = {
        defaultProps: {},
        styleOverrides: {
            root: {
                fontSize: '1.43rem',
                fontWeight: 300,
                lineHeight: 'normal',
                marginBottom: 2 * exports.SPACING_FACTOR,
                padding: 0,
            },
        },
    };
    const MuiDivider = {
        styleOverrides: {
            root: {
                position: 'relative',
                overflow: 'visible',
                borderColor: divider,
            },
        },
    };
    const MuiDrawer = {
        styleOverrides: {
            paper: {
                backgroundColor: 'background.default',
                backgroundImage: 'none',
                padding: 4 * exports.SPACING_FACTOR,
            },
        },
    };
    const MuiIconButton = {
        defaultProps: {
            disableFocusRipple: true,
            disableRipple: true,
            disableTouchRipple: true,
        },
        styleOverrides: {
            root: {
                borderRadius: 0,
                color: icon,
                padding: 0,
                '&:link': {
                    color: icon,
                },
                '&:hover, &:focus': {
                    color: primary.main,
                },
                '&:active': {
                    color: primary.dark,
                },
                '&:disabled, &.Mui-disabled': {
                    color: icon,
                    opacity: 0.5,
                },
            },
        },
    };
    const MuiInput = {
        styleOverrides: {
            root: Object.assign(Object.assign({}, body1), { [`&.${material_1.inputClasses.disabled}`]: {
                    opacity: 0.5,
                    color: text.secondary,
                    '-webkit-text-fill-color': text.secondary,
                    '&:before': {
                        borderBottomColor: text.secondary,
                        borderBottomStyle: 'solid',
                    },
                }, [`.${material_1.inputClasses.input}:focus`]: {
                    backgroundColor: 'transparent',
                } }),
            underline: {
                [`&:not(.${material_1.inputClasses.disabled})`]: {
                    '&:before': {
                        borderBottomColor: info.light,
                    },
                    '&:hover': {
                        '&:before': {
                            borderBottomColor: info.light,
                        },
                    },
                    [`&.${material_1.inputClasses.focused}, &:focus`]: {
                        '&:before': {
                            borderBottomColor: info.light,
                        },
                        '&:after': {
                            borderBottomColor: info.light,
                        },
                        [`&.${material_1.inputClasses.error}`]: {
                            '&:before': {
                                borderBottomColor: error.main,
                            },
                            '&:after': {
                                borderBottomColor: error.main,
                            },
                        },
                    },
                    [`&:active`]: {
                        '&:before': {
                            borderBottomColor: info.main,
                        },
                        '&:after': {
                            borderBottomColor: info.main,
                        },
                        [`&.${material_1.inputClasses.error}`]: {
                            '&:before': {
                                borderBottomColor: error.main,
                            },
                            '&:after': {
                                borderBottomColor: error.main,
                            },
                        },
                    },
                    [`&.${material_1.inputClasses.error}`]: {
                        '&:before': {
                            borderBottomColor: error.main,
                        },
                        '&:after': {
                            borderBottomColor: error.main,
                        },
                    },
                },
                [`&.${material_1.inputClasses.disabled}`]: {
                    opacity: 0.5,
                    '&:before': {
                        borderBottomColor: text.secondary,
                    },
                },
            },
        },
    };
    const MuiInputBase = {
        styleOverrides: {
            root: {
                [`&.${material_1.inputClasses.root}`]: {
                    marginTop: 2.75 * exports.SPACING_FACTOR,
                },
            },
        },
    };
    const MuiInputLabel = {
        defaultProps: {
            variant: 'standard',
        },
        styleOverrides: {
            root: Object.assign(Object.assign({}, body1), { lineHeight: 'normal', [`&.${material_1.inputLabelClasses.focused}`]: {
                    color: text.secondary,
                    bgcolor: 'none',
                } }),
            shrink: Object.assign({}, body2),
        },
    };
    const MuiLink = {
        styleOverrides: {
            root: {
                color: link.main,
                '&:hover, &:focus': {
                    color: link.hover,
                },
                '&:visited': {
                    color: link.visited,
                },
                '&[aria-disabled=true]': {
                    color: grey[400],
                    pointerEvents: 'none',
                },
            },
        },
    };
    const MuiList = {
        defaultProps: {
            disablePadding: true,
        },
    };
    const MuiListSubheader = {
        defaultProps: {
            disableSticky: true,
        },
        styleOverrides: {
            root: Object.assign(Object.assign({}, subtitle1), { backgroundColor: background.paper, lineHeight: 'normal', opacity: 1, paddingTop: exports.SPACING_FACTOR, paddingRight: exports.SPACING_FACTOR * 2, paddingBottom: exports.SPACING_FACTOR, paddingLeft: exports.SPACING_FACTOR * 2 }),
        },
    };
    const MuiListItemIcon = {
        styleOverrides: {
            root: {
                color: icon,
            },
        },
    };
    const MuiMenu = {
        defaultProps: {
            slotProps: {
                paper: {
                    elevation: 0,
                },
            },
        },
        styleOverrides: {
            paper: Object.assign({}, popperAndPopoverPaperStyles),
        },
    };
    const MuiMenuItem = {
        defaultProps: {
            disableRipple: true,
            disableTouchRipple: true,
        },
        styleOverrides: {
            root: ({ ownerState }) => (Object.assign(Object.assign(Object.assign(Object.assign({}, body1), { backgroundColor: background.paper, '&:hover': menuItemHoverStyles, [`&:focus, &.${material_1.menuItemClasses.focusVisible}`]: menuItemFocusedStyles, [`&.${material_1.menuItemClasses.selected}`]: menuItemSelectedStyles, [`&.${material_1.menuItemClasses.disabled}`]: menuItemDisabledStyles, [`& + .${material_1.dividerClasses.root}`]: {
                    marginTop: 1.25 * exports.SPACING_FACTOR,
                    marginBottom: 1.25 * exports.SPACING_FACTOR,
                }, [`.${material_1.listItemIconClasses.root}`]: {
                    minWidth: 0,
                    marginRight: exports.SPACING_FACTOR,
                } }), (!ownerState.dense && {
                minHeight: exports.DEFAULT_MENU_ITEM_HEIGHT,
                paddingTop: exports.SPACING_FACTOR,
                paddingBottom: exports.SPACING_FACTOR,
                paddingLeft: 2 * exports.SPACING_FACTOR,
                paddingRight: 2 * exports.SPACING_FACTOR,
            })), (ownerState.dense && {
                minHeight: exports.DENSE_MENU_ITEM_HEIGHT,
                paddingTop: exports.SPACING_FACTOR / 4,
                paddingBottom: exports.SPACING_FACTOR / 4,
                paddingLeft: 2 * exports.SPACING_FACTOR,
                paddingRight: 2 * exports.SPACING_FACTOR,
            }))),
        },
    };
    const MuiPaginationItem = {
        defaultProps: {
            slots: {
                previous: single_chevron_left_svg_1.default,
                next: single_chevron_right_svg_1.default,
            },
        },
        styleOverrides: {
            root: {
                '& svg': {
                    height: 16,
                    width: 16,
                    color: icon,
                },
                borderRadius: '2px',
                [`&.${material_1.paginationItemClasses.selected}`]: {
                    color: text.primary,
                    backgroundColor: secondary.light,
                },
                [`&:not(.${material_1.paginationItemClasses.selected})`]: {
                    color: text.secondary,
                },
            },
        },
    };
    const MuiPaper = {
        defaultProps: {
            elevation: 0,
        },
    };
    const MuiPopover = {
        defaultProps: {
            slotProps: {
                paper: {
                    elevation: 0,
                },
            },
        },
        styleOverrides: {
            paper: Object.assign({}, popperAndPopoverPaperStyles),
        },
    };
    const MuiRadio = {
        defaultProps: {
            disableRipple: true,
            disableFocusRipple: true,
            disableTouchRipple: true,
        },
        styleOverrides: {
            root: {
                [`&.${material_1.radioClasses.root}`]: {
                    borderWidth: exports.SPACING_FACTOR / 4,
                    paddingTop: exports.SPACING_FACTOR / 2,
                    paddingBottom: exports.SPACING_FACTOR / 2,
                    gap: exports.SPACING_FACTOR,
                },
                [`&:hover, &:focus, &:focus-visible`]: {
                    color: primary.main,
                },
                [`&.${material_1.radioClasses.checked}`]: {
                    color: primary.main,
                    [`&:hover, &:focus, &:focus-visible`]: {
                        color: primary.light,
                    },
                },
            },
        },
    };
    const MuiSelect = {
        defaultProps: {
            IconComponent: SelectIcon,
            MenuProps: {
                marginThreshold: 0,
                PaperProps: {
                    elevation: 0,
                },
                sx: {
                    mt: 1,
                },
            },
            variant: 'standard',
        },
        styleOverrides: {
            select: {
                [`&.${material_1.inputClasses.input}`]: {
                    paddingRight: exports.SPACING_FACTOR * 3.5,
                },
                paddingTop: exports.SPACING_FACTOR / 2,
                paddingBottom: exports.SPACING_FACTOR / 2,
                lineHeight: 'normal',
            },
            icon: {
                top: 'revert',
                right: exports.SPACING_FACTOR,
                fill: icon,
                [`&.${material_1.selectClasses.disabled}`]: {
                    fill: `${grey[400]} !important`,
                },
            },
        },
    };
    const MuiSlider = {
        styleOverrides: {
            root: {
                [`&.${material_1.sliderClasses.disabled}`]: {
                    opacity: 0.5,
                },
                [`.${material_1.sliderClasses.rail}`]: {
                    color: primary.main,
                    opacity: 0.5,
                },
                [`.${material_1.sliderClasses.track}`]: {
                    color: primary.main,
                },
                [`.${material_1.sliderClasses.thumb}`]: {
                    color: primary.main,
                },
                [`.${material_1.sliderClasses.mark}`]: {
                    backgroundColor: primary.main,
                },
                [`.${material_1.sliderClasses.markActive}`]: {
                    backgroundColor: primary.light,
                },
                [`.${material_1.sliderClasses.markLabel}`]: {
                    color: text.secondary,
                },
                [`.${material_1.sliderClasses.markLabelActive}`]: {
                    color: text.primary,
                },
            },
            thumb: {
                width: 12,
                height: 12,
                '&::before': {
                    boxShadow: 'none',
                },
            },
            markLabel: {
                fontSize: '1rem',
            },
        },
    };
    const MuiSwitch = {
        defaultProps: {
            disableFocusRipple: true,
            disableRipple: true,
        },
        styleOverrides: {
            colorPrimary: {
                '&:not(:hover)': {
                    [`&.${material_1.switchClasses.checked} .${material_1.switchClasses.thumb}`]: {
                        '&:after': {
                            backgroundColor: success.main,
                        },
                        '&:before': {
                            borderColor: info.dark,
                        },
                    },
                    [`& .${material_1.switchClasses.thumb}`]: {
                        '&:after': {
                            backgroundColor: error.main,
                        },
                    },
                },
                '&:hover': {
                    [`&.${material_1.switchClasses.checked} .${material_1.switchClasses.thumb}`]: {
                        '&:after': {
                            backgroundColor: success.light,
                        },
                    },
                    [`& .${material_1.switchClasses.thumb}`]: {
                        '&:after': {
                            backgroundColor: error.light,
                        },
                    },
                },
                [`&+.${material_1.switchClasses.track}, &.${material_1.switchClasses.checked}+.${material_1.switchClasses.track}`]: {
                    backgroundColor: info.dark,
                },
            },
            colorSecondary: {
                '&:not(:hover)': {
                    [`&.${material_1.switchClasses.checked} .${material_1.switchClasses.thumb}`]: {
                        '&:after': {
                            backgroundColor: primary.light,
                        },
                        '&:before': {
                            borderColor: info.dark,
                        },
                    },
                    [`& .${material_1.switchClasses.thumb}`]: {
                        '&:after': {
                            backgroundColor: primary.main,
                        },
                    },
                },
                '&:hover': {
                    [`&.${material_1.switchClasses.checked} .${material_1.switchClasses.thumb}`]: {
                        '&:after': {
                            backgroundColor: primary.lighter,
                        },
                    },
                    [`& .${material_1.switchClasses.thumb}`]: {
                        '&:after': {
                            backgroundColor: primary.light,
                        },
                    },
                },
                [`&+.${material_1.switchClasses.track}, &.${material_1.switchClasses.checked}+.${material_1.switchClasses.track}`]: {
                    backgroundColor: info.dark,
                },
            },
            root: {
                height: 16,
                padding: '5px 0',
                width: 28,
                '& .MuiTouchRipple-root': {
                    top: -9,
                },
                '&:not(:hover)': {
                    '& .MuiSwitch-colorDefault': {
                        [`&.${material_1.switchClasses.checked} .${material_1.switchClasses.thumb}`]: {
                            '&:after': {
                                backgroundColor: primary.main,
                            },
                            '&:before': {
                                borderColor: primary.main,
                            },
                        },
                        [`& .${material_1.switchClasses.thumb}`]: {
                            '&:after': {
                                backgroundColor: background.paper,
                            },
                        },
                        [`&+.${material_1.switchClasses.track}`]: {
                            backgroundColor: info.dark,
                        },
                        [`&.${material_1.switchClasses.checked}+.${material_1.switchClasses.track}`]: {
                            backgroundColor: primary.lighter,
                        },
                    },
                },
                '&:hover': {
                    [`& .MuiSwitch-colorDefault:not(.${material_1.switchClasses.disabled})`]: {
                        [`&.${material_1.switchClasses.checked} .${material_1.switchClasses.thumb}`]: {
                            '&:after': {
                                backgroundColor: primary.light,
                            },
                            '&:before': {
                                borderColor: primary.light,
                            },
                        },
                        [`& .${material_1.switchClasses.thumb}`]: {
                            '&:before': {
                                borderColor: info.light,
                            },
                        },
                        [`&+.${material_1.switchClasses.track}`]: {
                            backgroundColor: info.light,
                        },
                        [`&.${material_1.switchClasses.checked}+.${material_1.switchClasses.track}`]: {
                            backgroundColor: primary.lighter,
                        },
                    },
                    [`& .MuiSwitch-colorDefault.${material_1.switchClasses.disabled}`]: {
                        [`&.${material_1.switchClasses.checked} .${material_1.switchClasses.thumb}`]: {
                            '&:after': {
                                backgroundColor: primary.main,
                            },
                            '&:before': {
                                borderColor: primary.main,
                            },
                        },
                        [`&+.${material_1.switchClasses.track}`]: {
                            backgroundColor: info.dark,
                        },
                        [`&.${material_1.switchClasses.checked}+.${material_1.switchClasses.track}`]: {
                            backgroundColor: primary.lighter,
                        },
                    },
                },
            },
            switchBase: {
                padding: 0,
                [`&.${material_1.switchClasses.checked}`]: {
                    transform: 'translateX(12px)',
                },
                [`&+.${material_1.switchClasses.track}, &.${material_1.switchClasses.checked}+.${material_1.switchClasses.track}`]: {
                    opacity: 1,
                },
                [`&.${material_1.switchClasses.disabled}`]: {
                    backgroundColor: background.paper,
                    [`&+.${material_1.switchClasses.track}`]: {
                        opacity: 1,
                    },
                },
            },
            thumb: {
                backgroundColor: background.paper,
                boxShadow: 'none',
                height: 16,
                transition: 'all 0.3s ease-in-out',
                width: 16,
                '&:before': {
                    borderRadius: '50%',
                    border: '1px solid',
                    borderColor: info.dark,
                    content: '""',
                    height: 16,
                    position: 'absolute',
                    left: 0,
                    width: 16,
                },
                '&:after': {
                    borderRadius: '50%',
                    content: '""',
                    height: 14,
                    left: 1,
                    position: 'absolute',
                    top: 1,
                    width: 14,
                },
            },
            track: {
                backgroundColor: 'transparent',
                border: 'none',
                boxSizing: 'content-box',
                height: 6,
            },
        },
    };
    const MuiTab = {
        defaultProps: {
            disableFocusRipple: true,
            disableRipple: true,
            disableTouchRipple: true,
        },
        styleOverrides: {
            root: {
                minHeight: 40,
                minWidth: 'auto',
                opacity: 1,
                padding: `0 ${1.5 * exports.SPACING_FACTOR}px`,
                transition: 'background-color 150ms ease-in-out',
                [`&, &:hover, &:focus, &:focus-visible, &:visited, &.${material_1.tabClasses.disabled}`]: {
                    color: text.secondary,
                },
                '&:hover, &:focus, &:focus-visible': {
                    backgroundColor: background.chip,
                },
                [`&.${material_1.tabClasses.selected}`]: {
                    color: text.primary,
                    fontWeight: 500,
                },
                [`&.${material_1.tabClasses.disabled}`]: {
                    opacity: 0.5,
                },
            },
        },
    };
    const MuiTabs = {
        styleOverrides: {
            root: {
                minHeight: 40,
            },
            indicator: {
                height: 3,
                transition: 'none',
            },
            flexContainer: {
                gap: exports.SPACING_FACTOR * 2,
            },
        },
    };
    const MuiTable = {
        styleOverrides: {
            root: {
                borderCollapse: 'collapse',
            },
        },
    };
    const MuiTableCell = {
        styleOverrides: {
            body: {
                backgroundColor: background.paper,
                color: text.primary,
            },
            head: {
                backgroundColor: background.paperHover,
                color: text.secondary,
                fontSize: 12,
                fontWeight: 500,
            },
            root: {
                borderBottom: '1px solid',
                borderBottomColor: border,
                color: text.primary,
                fontSize: 12,
                padding: '8px 16px',
                '& a': {
                    color: link.main,
                    textDecoration: 'none',
                },
            },
        },
    };
    const MuiTableHead = {
        styleOverrides: {},
    };
    const MuiTableRow = {
        styleOverrides: {
            root: {
                border: '1px solid',
                borderColor: border,
            },
        },
    };
    const MuiTextField = {
        defaultProps: {
            variant: 'standard',
            SelectProps: {
                MenuProps: {
                    sx: { mt: 1 },
                },
            },
        },
        styleOverrides: {
            root: {
                '& ::placeholder': {
                    color: text.primary,
                },
                [`.${material_1.inputClasses.input}`]: {
                    paddingTop: exports.SPACING_FACTOR / 2,
                    paddingBottom: exports.SPACING_FACTOR / 2,
                },
                [`.${material_1.inputClasses.disabled}`]: {
                    opacity: 0.5,
                },
                // Handles autofill/autocomplete scenarios in Chrome
                // https://github.com/mui/material-ui/issues/283
                // https://stackoverflow.com/questions/2781549/removing-input-background-colour-for-chrome-autocomplete
                'input:-webkit-autofill': {
                    '-webkit-box-shadow': `0 0 0 30px ${background.paper} inset`,
                    '-webkit-text-fill-color': `${text.primary}`,
                    boxShadow: `0 0 0 30px ${background.paper} inset`,
                    caretColor: `${text.primary}`,
                    '&::spelling-error, &::grammar-error': {
                        color: `${text.primary}`,
                    },
                    '&::selection': {
                        color: 'HighlightText',
                        backgroundColor: 'Highlight',
                        '-webkit-text-fill-color': 'HighlightText',
                    },
                },
            },
        },
    };
    const MuiToggleButton = {
        defaultProps: {
            disableFocusRipple: true,
            disableRipple: true,
            size: 'medium',
        },
        styleOverrides: {
            root: ({ ownerState }) => (Object.assign(Object.assign(Object.assign(Object.assign({ border: '1px solid', borderColor: secondary.main, color: primary.contrastText, textTransform: 'none', lineHeight: 'normal', fontWeight: 400, [`&.${material_1.toggleButtonClasses.disabled}`]: {
                    opacity: 0.5,
                } }, (ownerState.size === 'small' && {
                paddingLeft: exports.SPACING_FACTOR * 1.5,
                paddingRight: exports.SPACING_FACTOR * 1.5,
                paddingTop: 0.75 * exports.SPACING_FACTOR,
                paddingBottom: 0.75 * exports.SPACING_FACTOR,
                fontSize: '1rem',
            })), (ownerState.size === 'medium' && {
                paddingLeft: exports.SPACING_FACTOR * 3,
                paddingRight: exports.SPACING_FACTOR * 3,
                paddingTop: 0.75 * exports.SPACING_FACTOR,
                paddingBottom: 0.75 * exports.SPACING_FACTOR,
                fontSize: '1rem',
                // Based on designs, the min width of the button is
                // minimum 112px content width +  1 * 1px borders + 2 * left and right padding
                minWidth: 114 + exports.SPACING_FACTOR * 3 * 2,
            })), (ownerState.color === 'standard' && {
                color: secondary.contrastText,
                svg: {
                    color: secondary.contrastText,
                    fill: secondary.contrastText,
                    '& path': {
                        fill: secondary.contrastText,
                    },
                },
                [`&.${material_1.toggleButtonClasses.selected}`]: {
                    backgroundColor: primary.main,
                },
                [`&.${material_1.toggleButtonClasses.selected}, &:hover, &:focus`]: {
                    color: primary.contrastText,
                    svg: {
                        color: primary.contrastText,
                        fill: primary.contrastText,
                        '& path': {
                            fill: primary.contrastText,
                        },
                    },
                },
                [`&.${material_1.toggleButtonClasses.selected}:hover,&.${material_1.toggleButtonClasses.selected}:focus,  &:hover, &:focus`]: {
                    backgroundColor: primary.light,
                },
            })), (ownerState.color === 'secondary' && {
                color: secondary.contrastText,
                svg: {
                    color: secondary.contrastText,
                    fill: secondary.contrastText,
                    '& path': {
                        fill: secondary.contrastText,
                    },
                },
                [`&.${material_1.toggleButtonClasses.selected}`]: {
                    color: secondary.contrastText,
                    backgroundColor: secondary.main,
                },
                [`&.${material_1.toggleButtonClasses.selected}:hover,&.${material_1.toggleButtonClasses.selected}:focus,  &:hover, &:focus`]: {
                    backgroundColor: secondary.light,
                },
            }))),
        },
    };
    const MuiPopper = {
        // This type isn't provided with our current MUI version.
        // Remove when upgrading to MUI version 5.14.13 (when it was fixed) or newer.
        // @ts-ignore
        styleOverrides: {
            root: {
                '&.MuiPopper-root': {
                    // Use 1300 to match modal/other menus:
                    // https://mui.com/material-ui/customization/z-index/
                    zIndex: 1300,
                },
            },
        },
    };
    const MuiTooltip = {
        defaultProps: {
            PopperProps: {
                placement: 'auto',
            },
        },
        styleOverrides: {
            tooltip: tooltipStyles,
        },
    };
    const MuiTypography = {
        defaultProps: {
            variantMapping: {
                subtitle1: 'p',
                subtitle2: 'p',
                inherit: 'p',
                code: 'code',
            },
        },
        styleOverrides: {
            root: {
                padding: 0,
            },
        },
    };
    return (0, material_1.createTheme)({
        components: {
            MuiAccordion,
            MuiAccordionDetails,
            MuiAccordionSummary,
            MuiAlert,
            MuiAutocomplete,
            MuiBadge,
            MuiButtonBase,
            MuiButton,
            MuiBreadcrumbs,
            MuiCard,
            MuiCardActions,
            MuiCardContent,
            MuiCheckbox,
            MuiChip,
            MuiCssBaseline,
            MuiDialog,
            MuiDialogActions,
            MuiDialogContent,
            MuiDialogTitle,
            MuiDivider,
            MuiDrawer,
            MuiFormControlLabel,
            MuiFormHelperText,
            MuiFormLabel,
            MuiIconButton,
            MuiInput,
            MuiInputBase,
            MuiInputLabel,
            MuiLink,
            MuiList,
            MuiListSubheader,
            MuiListItemIcon,
            MuiMenu,
            MuiMenuItem,
            MuiPaginationItem,
            MuiPaper,
            MuiPopper,
            MuiPopover,
            MuiRadio,
            MuiSelect,
            MuiSlider,
            MuiSwitch,
            MuiTab,
            MuiTabs,
            MuiTable,
            MuiTableCell,
            MuiTableHead,
            MuiTableRow,
            MuiTextField,
            MuiToggleButton,
            MuiTooltip,
            MuiTypography,
        },
        typography: {
            fontFamily: '"Lab Grotesque", sans-serif, Arial',
            h1,
            h2,
            h3,
            h4,
            h5,
            h6,
            subtitle1,
            subtitle2,
            body1,
            body2,
            button,
            caption,
            code,
        },
        spacing: exports.SPACING_FACTOR,
        palette: {
            background,
            border,
            chart,
            common,
            error,
            grey,
            icon,
            info,
            link,
            primary,
            secondary,
            tertiary,
            status,
            success,
            text,
            mode,
            warning,
            reputation,
            toast,
            dataGrid,
        },
        shape,
    });
};
exports.getCybertronTheme = getCybertronTheme;
var darkPalette_2 = require("./darkPalette");
Object.defineProperty(exports, "darkPalette", { enumerable: true, get: function () { return darkPalette_2.darkPalette; } });
var lightPalette_2 = require("./lightPalette");
Object.defineProperty(exports, "lightPalette", { enumerable: true, get: function () { return lightPalette_2.lightPalette; } });
exports.default = exports.getCybertronTheme;
